import { FC } from 'react'
import PremiumBundleTemplate from 'templates-page/premium-bundle'

export const PremiumBundle: FC = () => {
  return <PremiumBundleTemplate />
}
